
import styles from './Choice.module.scss'
import InputError from "@/Components/InputError";
import {FunctionComponent} from "react";

export default (
  {
    title,
    choices,
    value,
    onChange,
    onFocus,
    firstElementClassname,
    required,
    beige,
    error
    }: {
    title: string,
    choices: object, // object containing key and FunctionComponent
    value?: string,
    onChange: (key: any) => void,
    onFocus?: (key: any) => void,
    firstElementClassname?: string,
    required?: boolean,
    beige?: boolean,
    error?: string,
}) => {
  // keys are strings, so convert value booleans to string

  return <div className={`${styles.choicesContainer} ${beige && styles.beige}`}>
    <p>{title} {required && <span className={'color-primary font-bold'}>*</span>}</p>
    <div className={styles.choices}>
      {Object.entries(choices).map(([key, Component]: [string, FunctionComponent], index) => {
        const stringKey = (key === 'true') ? true : (key === 'false') ? false : key;
          return <fieldset
            className={`${stringKey === value ? styles.checked : ''} ${firstElementClassname && index === 0 ? firstElementClassname : ''}`}
            onClick={() => stringKey !== value ? onChange(stringKey) : null}
            // onFocus={() => stringKey !== value && onFocus ? onFocus(stringKey) : null}
            key={key}
          >
            <Component />
            <div className={styles.radio}>
              <i className={stringKey === value ? 'fa-regular fa-lg fa-circle-check' : 'fa-regular fa-lg fa-circle'}></i>
            </div>
          </fieldset>
        }
      )}
    </div>
    <InputError message={error} className="my-2 mb-2"/>
  </div>
}
